window.com = {};

CoreUtils = {
  roundNumber: function(num, digits) {
    var si = [
      { value: 1E18, symbol: "E" },
      { value: 1E15, symbol: "P" },
      { value: 1E12, symbol: "T" },
      { value: 1E9,  symbol: "G" },
      { value: 1E6,  symbol: "M" },
      { value: 1E3,  symbol: "k" }
    ], rx = /\.0+$|(\.[0-9]*[1-9])0+$/, i;
    for (i = 0; i < si.length; i++) {
      if (num >= si[i].value) {
        return (num / si[i].value).toFixed(digits).replace(rx, "$1") + si[i].symbol;
      }
    }
    return num.toFixed(digits).replace(rx, "$1");
  },
  getUrlParams: function() {
    var vars = [], hash;
    var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
    for(var i = 0; i < hashes.length; i++)
    {
        hash = hashes[i].split('=');
        vars.push(hash[0]);
        vars[hash[0]] = hash[1];
    }
    return vars;
  }
}

// custom component for input number
window.inputNumber = function(el, fn, optMax) {
  var min = el.attr('min') || false;
  var step = el.attr('step');
  var els = {};
  els.dec = el.prev();
  els.inc = el.next();
  
  if (!max) { var max = optMax; }

  el.each(function() {
    init($(this));
  });

  function init(el) {
    els.dec.on('click', decrement);
    els.inc.on('click', increment);
    function decrement() {
      var value = el[0].value;
      value = parseInt(value) - parseInt(step);
      if(!min || value >= min) {
        el[0].value = value;
        if (fn) {
          fn(value);
        } else {
          numberChange(value);
        }
      }
    }
    function increment() {
      var value = el[0].value;
      value = parseInt(value) + parseInt(step);
      if(!max || value <= max) {
        el[0].value = value++;
        if (fn) {
          fn(value);
        } else {
          numberChange(value);
        }
      }
    }
  }
}
